export const baseUrl: string = process.env.REACT_APP_API_URL || '';
export const bucketUrl: string = process.env.REACT_APP_CDN_URL || '';

export const getFullUrl = (urlStr: string): string => {
  if (!urlStr) return '';
  if (urlStr.startsWith('http://') || urlStr.startsWith('https://')) return urlStr;
  const cleanBucket = bucketUrl.endsWith('/') ? bucketUrl.slice(0, -1) : bucketUrl;
  const cleanUrl = urlStr.startsWith('/') ? urlStr : `/${urlStr}`;
  return `${cleanBucket}${cleanUrl}`;
};
